import reduxStore from 'redux/store'
import {clearResource, setResource, setSaveStatusError, setSaveStatusInfo} from "../redux/actions";
import {RestRequestBLOB, RestRequestBLOBBase64Encoded, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from "../libs/RestRequest";
import Endpoints from "../constants/Endpoints";
import RouterPath from "../libs/RouterPath";
import Tr from "../translations/Translations";
import isResponseValidWithStoredPasswordCheck from "../libs/isResponseValidWithStoredPasswordCheck";
import downloadFile from "../libs/downloadFile";
import {SignatureType} from "../constants/SignatureType";
import {OfferStatusType} from "../pages/contractor/demand/scenes/offer/components/common/constants/OfferStatusType";
import DemandOffersService from "./DemandOffersService";
import {StageSections} from "../pages/contractor/demand/scenes/offer/constants/StageSections";
import isResponseValid from "../libs/isResponseValid";
import DemandOffersOfferService from "./DemandOffersOfferService";
import {OfferMode} from "../pages/contractor/demand/scenes/offer/components/common/constants/OfferMode";


const ADDITIONAL_OFFER_EDIT = "additionalOfferEdit";
const ADDITIONAL_OFFER_POSITIONS_LOADED = "additionalOfferPositionsLoaded";

const postSavePositionData = async (demandId, stageId, supplierId, mode, data) => {
    let errorsAndAlerts;
    try {
        const params = {supplierId}
        const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_POSITION(demandId, stageId, supplierId), data, {params});

        if (isResponseValidWithStoredPasswordCheck(resp,
            () => postSavePositionData(demandId, stageId, supplierId, mode, data),
            () => defErrorCallback(demandId, stageId, supplierId),
            (err) => {
                errorsAndAlerts = err;
            },
            true
        )) {
            const {resources} = reduxStore.getState();
            const loaded = resources[ADDITIONAL_OFFER_POSITIONS_LOADED] || {};
            const newLoaded = {
                ...loaded,
                [getLoadedPositionKey(data.positionId)]: {
                    ...data,
                    placingType: null
                }
                //[getPositionKey(positionId)]: {...resp.result, priceType: PriceType.NET_GROSS, criteriums: resp.result.criteriums.map(x => ({...x, vatType: "OTHER", vatValue: 7, currency: "PLN"}))}
            }
            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_POSITIONS_LOADED, newLoaded))
            let filesResp = null;
            if (data.placingType) {
                filesResp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILES(demandId, stageId, mode, supplierId), {params});
            }

            const curEdit = resources[ADDITIONAL_OFFER_EDIT];
            const edit = {
                ...curEdit,
                positions: curEdit.positions.map(x => x.positionId === resp.result.positionId ? resp.result : x)
            }
            if (filesResp?.success) {
                edit.offerFiles = filesResp.result;
            }
            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_EDIT, edit));
            await DemandOffersService.getStageSection(demandId, stageId, StageSections.ADDITIONAL_OFFER_EDIT, supplierId);
            await DemandOffersService.getStageSection(demandId, stageId, StageSections.ADDITIONAL_OFFER_EDIT_ALT, supplierId);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
    if (Array.isArray(errorsAndAlerts)) {
        if (errorsAndAlerts.length > 0) {
            if (typeof errorsAndAlerts[0] === 'string' || errorsAndAlerts[0] instanceof String) {
                reduxStore.dispatch(setSaveStatusError(errorsAndAlerts[0]))
            }
        } else {
            reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
        }
    }
    return errorsAndAlerts;
}

const placeOffer = async (demandId, stageId, supplierId, onePositionMode, data, stageTr) => {
    const params = {supplierId}
    const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_PLACE_OFFER(demandId, stageId, supplierId), data, {params});

    if (isResponseValidWithStoredPasswordCheck(resp,
        () => placeOffer(demandId, stageId, supplierId, onePositionMode, data, stageTr),
        () => defErrorCallback(demandId, stageId, supplierId)
    )) {
        if (resp.result.status === OfferStatusType.NORMAL)
            reduxStore.dispatch(setSaveStatusInfo(supplierId ? stageTr("offer_placed_successfully_operator") : (onePositionMode ? stageTr("offer_placed_successfully") :
                stageTr("offer_placed_successfully_on_parts_x") + ": " + resp.result.positions.map(x => x.order).join(", "))));
        else if (resp.result.status === OfferStatusType.WAITING_SIGNATURE)
            reduxStore.dispatch(setSaveStatusInfo(stageTr("offer_waiting_for_signatures_x") + ": " + resp.result.missingSignatures));
        await DemandOffersService.getStageSections(demandId, stageId, supplierId)
        defErrorCallback(demandId, stageId, supplierId);
    }

}


const verifyBeforePlaceOffer = async (demandId, stageId, supplierId, positionIds) => {
    const params = {positionIds: positionIds ? positionIds.join(",") : undefined}
    return await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_VERIFICATION_BEFORE_PLACE(demandId, stageId, supplierId), {params});
}

const deleteOffer = async (demandId, stageId, positionIds) => {
    const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_DELETE_OFFER(demandId, stageId), {list: positionIds});

    if (isResponseValidWithStoredPasswordCheck(resp,
        () => deleteOffer(demandId, stageId, positionIds),
        () => defErrorCallback(demandId, stageId)
    )) {
        await DemandOffersService.getStageSections(demandId, stageId);
        defErrorCallback(demandId, stageId);
    }
}


const withdrawOffer = async (demandId, stageId, data, onePositionMode, stageTr) => {
    const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_WITHDRAW_OFFER(demandId, stageId), data);

    if (isResponseValidWithStoredPasswordCheck(resp,
        () => withdrawOffer(demandId, stageId, data, onePositionMode, stageTr),
        () => defErrorCallback(demandId, stageId)
    )) {
        if (resp.result.status === OfferStatusType.NORMAL)
            reduxStore.dispatch(setSaveStatusInfo(onePositionMode ? stageTr("offer_withdrawn_successfully") :
                stageTr("offer_withdrawn_successfully_on_parts_x") + ": " + resp.result.positions.map(x => x.order).join(", ")));
        else if (resp.result.status === OfferStatusType.WAITING_WITHDRAW_SIGNATURE)
            reduxStore.dispatch(setSaveStatusInfo(stageTr("offer_withdrawn_waiting_for_signatures_x") + ": " + resp.result.missingSignatures));
        await DemandOffersService.getStageSections(demandId, stageId)
        defErrorCallback(demandId, stageId);
    }
}

const signOffer = async (demandId, stageId, data, onePositionMode, stageTr) => {
    const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_SIGN_OFFER(demandId, stageId), data);

    if (isResponseValidWithStoredPasswordCheck(resp,
        () => signOffer(demandId, stageId, data, onePositionMode, stageTr),
        () => defErrorCallback(demandId, stageId)
    )) {

        if (resp.result.status === OfferStatusType.NORMAL)
            reduxStore.dispatch(setSaveStatusInfo(onePositionMode ? stageTr("offer_placed_successfully") :
                stageTr("offer_placed_successfully_on_parts_x") + ": " + resp.result.positions.map(x => x.order).join(", ")));
        else if (resp.result.status === OfferStatusType.WAITING_SIGNATURE)
            reduxStore.dispatch(setSaveStatusInfo(stageTr("offer_waiting_for_signatures_x") + ": " + resp.result.missingSignatures));

        await DemandOffersService.getStageSections(demandId, stageId)
        defErrorCallback(demandId, stageId);
    }
}

const signWithdraw = async (demandId, stageId, data, onePositionMode, stageTr) => {
    const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_SIGN_WITHDRAW(demandId, stageId), data);

    if (isResponseValidWithStoredPasswordCheck(resp,
        () => signWithdraw(demandId, stageId, data, onePositionMode, stageTr),
        () => defErrorCallback(demandId, stageId)
    )) {
        if (resp.result.status === OfferStatusType.NORMAL)
            reduxStore.dispatch(setSaveStatusInfo(onePositionMode ? stageTr("offer_withdrawn_successfully") :
                stageTr("offer_withdrawn_successfully_on_parts_x") + ": " + resp.result.positions.map(x => x.order).join(", ")));
        else if (resp.result.status === OfferStatusType.WAITING_SIGNATURE)
            reduxStore.dispatch(setSaveStatusInfo(stageTr("offer_withdrawn_waiting_for_signatures_x") + ": " + resp.result.missingSignatures));
        await DemandOffersService.getStageSections(demandId, stageId)
        defErrorCallback(demandId, stageId);
    }
}

const stopSigningOperation = async (demandId, stageId, positionId) => {
    const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_STOP_SIGNING_OPERATION(demandId, stageId, positionId));

    if (isResponseValidWithStoredPasswordCheck(resp,
        () => stopSigningOperation(demandId, stageId, positionId),
        () => defErrorCallback(demandId, stageId)
    )) {
        await DemandOffersService.getStageSections(demandId, stageId)
        defErrorCallback(demandId, stageId);
    }
}

const getDocumentToSign = async (demandId, stageId, data) => {
    try {
        if (data.signatureType === SignatureType.QUALIFIED || data.signatureType === SignatureType.PERSONAL_ID) {
            let resp = await RestRequestBLOBBase64Encoded(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_DOC_TO_SIGN(demandId, stageId), {
                data,
                method: 'post'
            })
            if (isResponseValidWithStoredPasswordCheck(resp,
                () => {
                },
                () => defErrorCallback(demandId, stageId)
            )) {
                return resp.result;
            }
        } else {
            const resp = await RestRequestBLOB(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_DOC_TO_SIGN(demandId, stageId), {data, method: 'post'})

            if (resp && isResponseValidWithStoredPasswordCheck(resp,
                () => getDocumentToSign(demandId, stageId, data),
                () => defErrorCallback(demandId, stageId)
            )) {
                return resp.result;
            }
            return true;
        }
    } catch (e) {
        console.error(e)
    }
}

const getDocumentToWithdraw = async (demandId, stageId, data) => {
    try {
        if (data.signatureType === SignatureType.QUALIFIED || data.signatureType === SignatureType.PERSONAL_ID) {
            const resp = await RestRequestBLOBBase64Encoded(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_WITHDRAW_DOC_TO_SIGN(demandId, stageId), {
                data,
                method: 'post'
            })
            if (isResponseValidWithStoredPasswordCheck(resp,
                () => {
                },
                () => defErrorCallback(demandId, stageId)
            )) {
                return resp.result;
            }
        } else {
            const resp = await RestRequestBLOB(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_WITHDRAW_DOC_TO_SIGN(demandId, stageId), {data, method: 'post'})

            if (resp && isResponseValidWithStoredPasswordCheck(resp,
                () => getDocumentToWithdraw(demandId, stageId, data),
                () => defErrorCallback(demandId, stageId)
            )) {
                return resp.result;
            }
            return true;
        }
    } catch (e) {
        console.error(e)
    }
}


const getDownloadOfferFileUrl = async (demandId, stageId, mode, fileId, supplierId) => {
    const params = {supplierId}
    const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILE_DOWNLOAD_URL(demandId, stageId, mode, fileId, supplierId), {params});
    if (isResponseValidWithStoredPasswordCheck(resp,
        () => {
        },
        () => {
        }
    )) {
        return resp.result;
    }
}

const getDownloadOfferFile = async (demandId, stageId, mode, fileId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILE_DOWNLOAD_URL(demandId, stageId, mode, fileId, supplierId), {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => getDownloadOfferFile(demandId, stageId, mode, fileId, supplierId),
            () => {
            }
        )) {
            downloadFile({url: resp.result})
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getDownloadOfferFilesZip = async (demandId, stageId, supplierId) => {
    const params = {supplierId}
    await RestRequestBLOB(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_FILE_DOWNLOAD_ZIP(demandId, stageId, supplierId), {params});
}

const getDownloadEspdFile = async (demandId, stageId, mode, fileId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_ESPD_DOWNLOAD_URL(demandId, stageId, mode, fileId, supplierId), {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => getDownloadEspdFile(demandId, stageId, mode, fileId, supplierId),
            () => {
            }
        )) {
            downloadFile({url: resp.result})
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}
const signFile = async (demandId, stageId, fileId, data) => {
    try {
        const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_FILE_ID_SIGN_FILE(demandId, stageId, fileId), data);

        if (isResponseValid(resp, (e) => {
            throw new Error(e)
        })) {
            await _processAddNewFiles(demandId, stageId, OfferMode.EDIT, undefined, resp);
            return true;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const postOfferFiles = async (demandId, stageId, mode, supplierId, data) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_FILE(demandId, stageId, supplierId), {files: data}, {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => postOfferFiles(demandId, stageId, mode, supplierId, data),
            () => defErrorCallback(demandId, stageId, supplierId)
        )) {
            await _processAddNewFiles(demandId, stageId, mode, supplierId, resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const _processAddNewFiles = async (demandId, stageId, mode, supplierId, resp) => {
    const {resources} = reduxStore.getState();
    let curEdit = resources[ADDITIONAL_OFFER_EDIT];
    let touchedPositions;

    if (curEdit.passiveOfferForm) {
        touchedPositions = [curEdit.positions[0].positionId]
    } else {
        touchedPositions = [...new Set(resp.result.filter(x => !!x.positionId).map(x => x.positionId))];
    }
    let positions = [];
    if (touchedPositions.length > 0) {
        const params = {
            positionIds: touchedPositions.join(","),
            supplierId
        }
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITIONS(demandId, stageId, mode, supplierId), {params});
        if (resp.success) {
            positions = resp.result;
        }
        //odświeżam reduxa bo mogło się pozmieniać
        curEdit = resources[ADDITIONAL_OFFER_EDIT];
    }

    const tmpOfferFiles = curEdit.offerFiles.map(of => {
        const updatedOf = resp.result.find(x => x.identity === of.identity);
        return updatedOf ? updatedOf : of;
    });
    resp.result.forEach(x => {
        if (!curEdit.offerFiles.find(o => o.identity === x.identity))
            tmpOfferFiles.push(x);
    });

    const edit = {
        ...curEdit,
        offerFiles: [
            ...tmpOfferFiles
        ],
        positions: curEdit.positions.map(x => {
            const pos = positions.find(p => p.positionId === x.positionId);
            return pos ? pos : x;
        })
    }
    reduxStore.dispatch(setResource(ADDITIONAL_OFFER_EDIT, edit));
    await DemandOffersService.getStageSection(demandId, stageId, StageSections.ADDITIONAL_OFFER_EDIT, supplierId);
}

const deleteOfferFile = async (demandId, stageId, mode, supplierId, fileId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestDELETE(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_FILE_ID(demandId, stageId, fileId, supplierId), {params});

        if (isResponseValidWithStoredPasswordCheck(resp,
            () => deleteOfferFile(demandId, stageId, mode, supplierId, fileId),
            () => {
            }
        )) {

            const {resources} = reduxStore.getState();
            let curEdit = resources[ADDITIONAL_OFFER_EDIT];


            let positionId;
            if (curEdit.passiveOfferForm) {
                positionId = curEdit.positions[0].positionId;
            } else {
                const file = curEdit.offerFiles.find(x => x.identity === fileId);
                if (file) {
                    positionId = file.positionId;
                }
            }

            let position;
            if (positionId) {
                const params = {
                    positionIds: positionId,
                    supplierId
                }
                const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITIONS(demandId, stageId, mode, supplierId), {params});
                if (resp.success) {
                    position = resp.result[0];
                }
                //odświeżam reduxa bo mogło się pozmieniać
                curEdit = resources[ADDITIONAL_OFFER_EDIT];
            }

            let tmpOfferFiles = curEdit.offerFiles.filter(x => x.identity !== fileId);
            if (!!resp.result) {
                tmpOfferFiles = tmpOfferFiles.map(x => {
                    return x.identity === resp.result.identity ? resp.result : x;
                })
            }

            const edit = {
                ...curEdit,
                offerFiles: tmpOfferFiles,
                positions: curEdit.positions.map(x => position && position.identity === x.identity ? position : x)
            }
            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_EDIT, edit));
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const editOfferFile = async (demandId, stageId, fileId, mode, supplierId, data) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestPUT(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_FILE_ID(demandId, stageId, fileId, supplierId), data, {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => editOfferFile(demandId, stageId, fileId, mode, supplierId, data),
            () => {
            }
        )) {

            const {resources} = reduxStore.getState();
            let curEdit = resources[ADDITIONAL_OFFER_EDIT];


            let positionId;
            if (curEdit.passiveOfferForm) {
                positionId = curEdit.positions[0].positionId;
            } else {
                const file = curEdit.offerFiles.find(x => x.identity === fileId);
                if (file) {
                    positionId = file.positionId;
                }
            }

            let position;
            if (positionId) {
                const params = {
                    positionIds: positionId,
                    supplierId
                }
                const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITIONS(demandId, stageId, mode, supplierId), {params});
                if (resp.success) {
                    position = resp.result[0];
                }
                //odświeżam reduxa bo mogło się pozmieniać
                curEdit = resources[ADDITIONAL_OFFER_EDIT];
            }

            const edit = {
                ...curEdit,
                offerFiles: curEdit.offerFiles.map(x => x.identity === resp.result.identity ? resp.result : x),
                positions: curEdit.positions.map(x => position && position.identity === x.identity ? position : x)
            }
            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_EDIT, edit));

        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }

}

const editOfferFiles = async (demandId, stageId, mode, supplierId, data) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestPUT(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_FILES(demandId, stageId, supplierId), data, {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => editOfferFiles(demandId, stageId, mode, supplierId, data),
            () => defErrorCallback(demandId, stageId, supplierId)
        )) {
            const {resources} = reduxStore.getState();
            let curEdit = resources[ADDITIONAL_OFFER_EDIT];
            let touchedPositions;

            if (curEdit.passiveOfferForm) {
                touchedPositions = [curEdit.positions[0].positionId]
            } else {
                touchedPositions = [...new Set(resp.result.filter(x => !!x.positionId).map(x => x.positionId))];
            }
            let positions = [];
            if (touchedPositions.length > 0) {
                const params = {
                    positionIds: touchedPositions.join(","),
                    supplierId
                }
                const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITIONS(demandId, stageId, mode, supplierId), {params});
                if (resp.success) {
                    positions = resp.result;
                }
                //odświeżam reduxa bo mogło się pozmieniać
                curEdit = resources[ADDITIONAL_OFFER_EDIT];
            }

            const edit = {
                ...curEdit,
                offerFiles: curEdit.offerFiles.map(x => resp.result.find(y => y.identity === x.identity) || x),
                positions: curEdit.positions.map(x => {
                    const pos = positions.find(p => p.positionId === x.positionId);
                    return pos ? pos : x;
                })
            }
            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_EDIT, edit));
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getOfferEdit = async (demandId, stageId, mode, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE(demandId, stageId, mode, supplierId), {params});
        if (isResponseValid(resp,
            () => defErrorCallback(demandId, stageId)
        )) {
            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_EDIT, resp.result))
        }
    } catch (e) {
        console.error(e);
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getOfferPosition = async (demandId, stageId, mode, positionId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_MODE_POSITION_ID(demandId, stageId, mode, positionId, supplierId), {params});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => getOfferPosition(demandId, stageId, mode, positionId, supplierId),
            () => defErrorCallback(demandId, stageId, supplierId)
        )) {
            const {resources} = reduxStore.getState();
            const loaded = resources[ADDITIONAL_OFFER_POSITIONS_LOADED] || {};

            const newLoaded = {
                ...loaded,
                [getLoadedPositionKey(positionId)]: resp.result
                //[getPositionKey(positionId)]: {...resp.result, priceType: PriceType.NET_GROSS, criteriums: resp.result.criteriums.map(x => ({...x, vatType: "OTHER", vatValue: 7, currency: "PLN"}))}
            }

            reduxStore.dispatch(setResource(ADDITIONAL_OFFER_POSITIONS_LOADED, newLoaded))
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const requireWithdrawEncryption = async (demandId, stageId, positionIds) => {
    try {
        const resp = await RestRequestPOST(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_REQUIRE_WITHDRAW_ENCRYPTION(demandId, stageId), {positionIds});
        if (isResponseValidWithStoredPasswordCheck(resp,
            () => defErrorCallback(demandId, stageId),
            () => defErrorCallback(demandId, stageId)
        )) {
            return resp.result;
        } else {
            throw new Error(resp);
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getSnapshots = async (demandId, stageId, positionId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_SNAPSHOTS(demandId, stageId, positionId, supplierId), {params});
        if (isResponseValid(resp, (e) => {
            throw new Error(e)
        })) {
            return resp.result;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const downloadSnapshot = async (demandId, stageId, positionId, snapshotId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestBLOB(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_SNAPSHOT_ID(demandId, stageId, positionId, snapshotId, supplierId), {params});
        if (resp && isResponseValidWithStoredPasswordCheck(resp,
            () => downloadSnapshot(demandId, stageId, positionId, snapshotId, supplierId),
            () => defErrorCallback(demandId, stageId)
        )) {
            return resp.result;
        }
        return true;
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const getVerifications = async (demandId, stageId, positionId, supplierId) => {
    try {
        const params = {supplierId}
        const resp = await RestRequestGET(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_VERIFICATIONS(demandId, stageId, positionId, supplierId), {params});
        if (isResponseValid(resp, (e) => {
            throw new Error(e)
        })) {
            return resp.result;
        }
    } catch (e) {
        console.error(e)
        reduxStore.dispatch(setSaveStatusError(Tr('internal_server_error')));
    }
}

const downloadVerifications = async (demandId, stageId, positionId, supplierId, positionIds) => {
    const data = {
        list: positionIds
    }
    const params = {supplierId}
    await RestRequestBLOB(Endpoints.DEMAND_ADDITIONAL_OFFERS_OFFER_VERIFICATIONS(demandId, stageId, positionId, supplierId), {data, params, method: 'post'})
}

const defErrorCallback = (demandId, stageId, supplierId) => {

    if (supplierId) {
        const {resources} = reduxStore.getState()
        if (resources[DemandOffersService.DEMAND_STAGES_LIST]) {
            const stage = resources[DemandOffersService.DEMAND_STAGES_LIST].find(x => x.supplierId === supplierId);
            if (stage?.contractorDepartmentId) {
                RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.purchaserDemand.PURCHASER_DEMAND_ID_OFFER_CONTRACTOR_ID_STAGE_ID, {
                    id: demandId,
                    contractorDepartmentId: stage.contractorDepartmentId,
                    stageId
                }));
            }
        }
    } else {
        RouterPath.redirectWithoutHistory(RouterPath.createPath(RouterPath.ctrDemand.steps.CTR_DEMAND_ID_OFFER_STAGE_ID, {
            id: demandId,
            stageId
        }));
    }
}
const clearResources = (resId) => reduxStore.dispatch(clearResource(resId));

const getLoadedPositionKey = DemandOffersOfferService.getLoadedPositionKey;

export default {
    getOfferEdit,
    getDownloadOfferFile,
    getDownloadOfferFileUrl,
    getDownloadOfferFilesZip,
    signFile,
    postOfferFiles,
    deleteOfferFile,
    editOfferFile,
    editOfferFiles,
    getDownloadEspdFile,
    getOfferPosition,
    postSavePositionData,
    placeOffer,
    withdrawOffer,
    signOffer,
    signWithdraw,
    getDocumentToSign,
    getDocumentToWithdraw,
    stopSigningOperation,
    clearResources,
    requireWithdrawEncryption,
    deleteOffer,
    getSnapshots,
    downloadSnapshot,
    getVerifications,
    downloadVerifications,
    verifyBeforePlaceOffer,
    ADDITIONAL_OFFER_EDIT,
    ADDITIONAL_OFFER_POSITIONS_LOADED
}